import { useEffect, useRef } from 'react';
import FinalSettlementBaseHeader from './FinalSettlementBaseHeader';
import CheckMarkIcon from '../assets/icons/CheckMarkIcon.svg?react';
import XButton from './common/XButton';

const wrapperClasses =
  'relative overflow-hidden p-1 rounded my-6 ' +
  'bg-primary';

const successClasses =
  'relative min-h-125 bg-white bg-no-repeat bg-center bg-cover ' +
  'flex flex-col items-center justify-center py-12 px-8 overflow-hidden';

const centerClasses = 'relative py-10 px-8 max-w-[calc(var(--spacing)*150)] w-full text-center';

const checkCircleClasses =
  'w-14.5 h-14.5 bg-success rounded-full flex items-center justify-center ' +
  'mx-auto mb-6 shadow-[0_4px_12px_rgba(63,125,31,0.35)]';

const titleClasses = 'text-2xl font-semibold text-content mb-6';

const descClasses = 'text-base font-normal text-content leading-[1.6] mb-9';

const valuesClasses = 'mt-3';

const rowClasses = 'flex justify-center gap-6 font-bold text-base mb-2.5';

const closeBtnClasses =
  'absolute right-6 bottom-6 z-10 py-3 px-12 text-base rounded-lg';

export const FinalSettlementSuccess = ({ settlements, onClose }) => {
  const confettiRef = useRef(null);

  useEffect(() => {
    if (confettiRef.current) {
      createConfetti();
    }
  }, []);

  const createConfetti = () => {
    const confettiContainer = confettiRef.current;
    if (!confettiContainer) return;

    const colors = ['#FF6B6B', '#4ECDC4', '#45B7D1', '#FFA07A', '#98D8C8', '#F7DC6F', '#BB8FCE', '#85C1E2', '#F8B739', '#6C5CE7', '#A8E6CF', '#FF8B94'];
    const shapes = ['polygon', 'ellipse', 'rectangle', 'star'];

    for (let i = 0; i < 100; i++) {
      const confetti = document.createElement('div');
      confetti.className = `confetti-piece ${shapes[Math.floor(Math.random() * shapes.length)]}`;
      confetti.style.left = Math.random() * 100 + '%';
      confetti.style.top = Math.random() * 100 + '%';
      confetti.style.backgroundColor = colors[Math.floor(Math.random() * colors.length)];
      confetti.style.animation = `confetti-float ${2 + Math.random() * 3}s ease-in-out infinite`;
      confetti.style.animationDelay = Math.random() * 2 + 's';
      confetti.style.opacity = Math.random() * 0.6 + 0.4;


      confettiContainer.appendChild(confetti);
    }
  };

  return (
    <div>
      <div className={wrapperClasses}>
        <FinalSettlementBaseHeader />

        <div className={successClasses}>
          <div ref={confettiRef} className="confetti-container"></div>
          <div className={centerClasses}>
            <div className={checkCircleClasses}>
              <CheckMarkIcon />
            </div>

            <h2 className={titleClasses}>Case Settled!</h2>

            <p className={descClasses}>
              Congratulations! By entering this information, you've unlocked<br />
              more accurate case analytics and performance insights!
            </p>

            <div className={valuesClasses}>
              {settlements.map((s, i) => (
                <div key={i} className={rowClasses}>
                  <span>{s.name}</span>
                  <span className="font-bold">${s.amount?.toLocaleString()}</span>
                </div>
              ))}
            </div>
          </div>

          <XButton
            variant="outlinePrimary"
            className={closeBtnClasses}
            onClick={onClose}
          >
            Close
          </XButton>
        </div>
      </div>
    </div>
  );
};
